/**
 * The four Kit/Group Member Rows scopes, as antd `Segmented` options.
 * Shared by `ViewVisibilityControl`'s checklist rows and `VisibilityMatrixCell`,
 * which must offer the identical vocabulary — a user who learns the scope in one
 * surface reads the same four words in the other. The four states exist because
 * `kitMemberHiddenTypes` and `groupMemberHiddenTypes` are independent stored
 * lists: collapsing them into a boolean makes kit-only blanking unauthorable.
 */
import type { MemberRowsScope } from './ViewVisibility.types';

export const memberRowsOptions: { value: MemberRowsScope; label: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'kit', label: 'Kit' },
    { value: 'group', label: 'Group' },
    { value: 'both', label: 'Both' },
];
